import React, { useContext, useState } from 'react'
import { Form, Button, Row, Col, Card, Container, Input} from 'react-bootstrap';
import { useNavigate } from 'react-router'
//import { login } from "../../utils/utils";
import { loginUser } from "../../services/authService";

import { store, StateProvider } from '../../Store';

export default function Login() {

  const navigate = useNavigate();
  const {state, dispatch} = useContext(store);

  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');

  const submitLogin = (e) => {
    e.preventDefault();

    // setLoading(true);

    // form.current.validateAll();

    //if (checkBtn.current.context._errors.length === 0) {
      loginUser(username, password).then(
        (result) => {
          // navigate('/admin');
          //window.location.href = '/admin';
          window.location.reload();
        }
      )
      .catch((error) => {
        const errorStatus = error.message;
        // setLoading(false);

        if (['401', '404'].includes(errorStatus)) {
          alert('Nombre de usuario no existe o contraseña incorrecta.');
        }

      });
    //} else {
    //  setLoading(false);
    //}
  };

  const loginForm = (
    <>
    <Form>
      <Form.Group className="admin-content-group">
      <div className="login-title">Panel de <br />administración</div>
      <div className="login-text-box">
      <Form.Control
        type="user"
        id="inputEmail"
        className="form-control"
        placeholder="Usuario"
        required autofocus
        onChange={(e) => { setUsername( e.target.value ); }}
      />
      </div>
      <div className="login-text-box">
      <Form.Control
        type="password"
        id="inputPassword"
        className="form-control"
        placeholder="Contraseña"
        required
        onChange={(e) => { setPassword( e.target.value ); }}
      />
      </div>
      <div className="login-text-box">
        <Button className="odisea-form-button-submit" type="_submit" onClick={submitLogin}>Ingresar</Button>
      </div>
      </Form.Group>
    </Form>
    </>
  )
  return (
    <>
      <div className="odisea-page-home odisea-page-home-flex">
        <Card className="login-card">
          <Card.Body>{ loginForm }</Card.Body>
        </Card>
      </div>
   </>
  )
}
